module.exports = __webpack_public_path__ + "img/attachment-success.e7c6c8f4.svg";